var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardi5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 241,
    viewBox: "0 0 299 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 4.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 33.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 62.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 91.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 120.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 149.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 178.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 207.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 236.5,
    r: 4.5,
    fill: "#AEFF63"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardi5);
export default __webpack_public_path__ + "static/media/cardi5.e6948fd0277c6687c0c62c417da386a6.svg";
export { ForwardRef as ReactComponent };